import conditionalProperties from 'classnames';
import classNames from 'classnames';
import React from 'react';

import { ICircularBgImageProps } from '@/shared/components/atoms/CircularBgImage/ICircularBgImage';
import NextImage from '@/shared/components/atoms/NextImage';

const CircularBgImage: React.FC<ICircularBgImageProps> = ({
  imageSrc,
  imageClassName,
  bgColor,
  size,
}) => {
  const baseCircleSizes = conditionalProperties({
    '45': size === 'xl',
    '32': size === 'lg',
    '24': size === 'md',
    '20': size === 'sm',
    '16': size === 'xs',
    '12': size === 'xxs',
  });
  //  INFO: https://tailwindcss.com/docs/content-configuration#dynamic-class-names
  const baseCircleSizeClasses = conditionalProperties({
    'w-[45px] h-[45px]': size === 'xl',
    'w-[32px] h-[32px]': size === 'lg',
    'w-[24px] h-[24px]': size === 'md',
    'w-[20px] h-[20px]': size === 'sm',
    'w-[16px] h-[16px]': size === 'xs',
    'w-[12px] h-[12px]': size === 'xxs',
  });
  return (
    <div
      className={classNames(
        'relative flex items-center justify-center rounded-full',
        baseCircleSizeClasses,
        bgColor
      )}
    >
      {imageSrc && (
        <NextImage
          src={imageSrc}
          alt=''
          height={Number(baseCircleSizes) - 2}
          width={Number(baseCircleSizes) - 2}
          className={imageClassName}
        />
      )}
    </div>
  );
};

export default CircularBgImage;
